var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0549 25.1518L22.4537 28.3398C22.2203 28.4664 21.9702 28.529 21.7231 28.529C21.4592 28.529 21.1983 28.4573 20.9634 28.3169C20.5118 28.0485 20.2418 27.5771 20.2418 27.0524V20.6748C20.2418 20.1409 20.5195 19.659 20.9832 19.392C21.4439 19.1251 21.993 19.122 22.4568 19.389L28.0549 22.5769C28.5156 22.8362 28.8023 23.332 28.8023 23.8628C28.8023 24.3967 28.5156 24.8894 28.0549 25.1518ZM37.6617 16.027C37.2666 14.3949 36.0341 13.0892 34.4462 12.6117C31.7509 11.7224 15.7023 11.7728 13.2434 12.6651C11.6494 13.1197 10.4093 14.4315 10.0264 16.0209C9.12338 18.6614 9.12338 29.0994 10.0127 31.7109C10.455 33.3049 11.6936 34.5664 13.1931 34.9828C14.5125 35.4618 19.2244 35.6982 23.9089 35.6982C28.5628 35.6982 33.1924 35.4648 34.434 34.9981C36.028 34.5252 37.2651 33.2149 37.6419 31.6499C38.5418 29.0598 38.5449 18.6492 37.6617 16.027Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.189fdc85cdf86f501e26cc1348066027.svg";
export { ForwardRef as ReactComponent };